import { render, staticRenderFns } from "./ClasificacionGenerosPorArtistas.vue?vue&type=template&id=1e0683d8&"
import script from "./ClasificacionGenerosPorArtistas.vue?vue&type=script&lang=js&"
export * from "./ClasificacionGenerosPorArtistas.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionGenerosPorArtistas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports